export const ROWS_PER_PAGE_LIST = [7, 14, 21, 28, 35, 42, 49, 56, 63, 70]
